<template>
  <div>
    <!-- Navigation -->
    <navigation-bar></navigation-bar>

    <!-- Hauptinhalt -->
    <div class="container-fluid mt-4">
      <!-- Kopfzeile mit Werten aus postData -->
      <h3>
        Heti fuvarok
        <small class="text-muted">
          (fuvarszervező: {{ postData.fsz }}, {{ postData.ev }}/{{ postData.het }} hét)
        </small>
      </h3>

      <!-- Tabelle mit Scrollbalken -->
      <div class="table-responsive-wrapper">
        <table class="table table-striped">
          <thead class="sticky-header">

         
              <tr>
                <th>
                  <div class="input-with-icon">
                    <i class="fas fa-search"></i>
                    <input v-model="filters.m_datumtol" type="text" class="form-control" />
                  </div>
                </th>
                <th>
                  <div class="input-with-icon">
                    <i class="fas fa-search"></i>
                    <input v-model="filters.megrendelo" type="text" class="form-control" />
                  </div>
                </th>
                <th>
                  <div class="input-with-icon">
                    <i class="fas fa-search"></i>
                    <input v-model="filters.viszonylat" type="text" class="form-control" />
                  </div>
                </th>
                <th>
                  <div class="input-with-icon">
                    <i class="fas fa-search"></i>
                    <input v-model="filters.nagyar" type="text" class="form-control" />
                  </div>
                </th>
                <th>
                  <div class="input-with-icon">
                    <i class="fas fa-search"></i>
                    <input v-model="filters.kisar" type="text" class="form-control" />
                  </div>
                </th>
                <th>
                  <div class="input-with-icon">
                    <i class="fas fa-search"></i>
                    <input v-model="filters.felrakas_napja" type="text" class="form-control" />
                  </div>
                </th>
                <th>
                  <div class="input-with-icon">
                    <i class="fas fa-search"></i>
                    <input v-model="filters.lerakas_napja" type="text" class="form-control" />
                  </div>
                </th>
                <th>
                  <div class="input-with-icon">
                    <i class="fas fa-search"></i>
                    <input v-model="filters.rendszam" type="text" class="form-control" />
                  </div>
                </th>
                <th>
                  <div class="input-with-icon">
                    <i class="fas fa-search"></i>
                    <input v-model="filters.potkocsi" type="text" class="form-control" />
                  </div>
                </th>
                <th>
                  <div class="input-with-icon">
                    <i class="fas fa-search"></i>
                    <input v-model="filters.felsegjel" type="text" class="form-control" />
                  </div>
                </th>
                <th>
                  <div class="input-with-icon">
                    <i class="fas fa-search"></i>
                    <input v-model="filters.fuvarozo" type="text" class="form-control" />
                  </div>
                </th>
                <th>
                  <div class="input-with-icon">
                    <i class="fas fa-search"></i>
                    <input v-model="filters.fel_suly" type="text" class="form-control" />
                  </div>
                </th>
                <th>
                  <div class="input-with-icon">
                    <i class="fas fa-search"></i>
                    <input v-model="filters.le_suly" type="text" class="form-control" />
                  </div>
                </th>
                <th>
                  <div class="input-with-icon">
                    <i class="fas fa-search"></i>
                    <input v-model="filters.eltero_ar" type="text" class="form-control" />
                  </div>
                </th>
                <th>
                  <div class="input-with-icon">
                    <i class="fas fa-search"></i>
                    <input v-model="filters.eltero_kisar" type="text" class="form-control" />
                  </div>
                </th>
              </tr>



            <tr>
              <th>Megr. dátum</th>
              <th>Megrendelő</th>
              <th>Viszonylat</th>
              <th>Megr. nagyár</th>
              <th>Megr. kisár</th>
           
              <th>Rendszám</th>
              <th>Potkocsi</th>
              <th>Felségjel</th><th>Fuvarozó</th>
              <th>Felrakás napja</th>
              <th>Lerakás napja</th>
              <th>Fel súly</th>
              <th>Le súly</th>
              <th>Elt.ár</th>
              <th>Száll.kisár</th>
              
            </tr>
          </thead>
          <tbody>
            <tr v-for="truck in filteredTrucks" :key="truck.mellek_az" @click="openTruckDetails(truck)">
              <td>{{ truck.m_datumtol }}</td>
              <td>{{ truck.megrendelo }}</td>
              <td>{{ truck.felrako }} - {{ truck.lerako }} - {{ truck.cikk }}</td>
              <td>{{ truck.nagyar }}</td>
              <td>{{ truck.kisar }}</td>
              <td>{{ truck.rendszam }}</td>
              <td>{{ truck.potkocsi }}</td>
              <td>{{ truck.felsegjel }}</td>
              <td>{{ truck.fuvarozo }}</td>
         <!-- Felrakás napja -->
            <td
              :class="{ 'cell-missing': !truck.felrakas_napja }"
              @click.stop="enableEdit(truck, 'felrakas_napja')"
            >
              <template v-if="isEditing(truck, 'felrakas_napja')">
                <input
                  ref="editInput"
                  type="date"
                  v-model="editingCell.value"
                  @keyup.enter="saveEdit(truck, 'felrakas_napja')"
                  @keyup.esc="cancelEdit"
                  class="form-control"
                  autofocus
                  style="width: 140px; display: inline-block;"
                />
                <button
                  @mousedown.prevent="saveEdit(truck, 'felrakas_napja')"
                  class="btn btn-sm btn-success ml-1"
                  title="Speichern"
                  style="padding:2px 6px;"
                >
                  ✔
                </button>
                <button
                  @mousedown.prevent="cancelEdit"
                  class="btn btn-sm btn-light ml-1"
                  title="Abbrechen"
                  style="padding:2px 6px;"
                >
                  ✕
                </button>
              </template>
              <template v-else>
                {{ truck.felrakas_napja }}
              </template>
            </td>

            <!-- Lerakás napja -->
            <td
              :class="{ 'cell-missing': !truck.lerakas_napja }"
              @click.stop="enableEdit(truck, 'lerakas_napja')"
            >
              <template v-if="isEditing(truck, 'lerakas_napja')">
                <input
                  ref="editInput"
                  type="date"
                  v-model="editingCell.value"
                  @keyup.enter="saveEdit(truck, 'lerakas_napja')"
                  @keyup.esc="cancelEdit"
                  class="form-control"
                  autofocus
                  style="width: 140px; display: inline-block;"
                />
                <button
                  @mousedown.prevent="saveEdit(truck, 'lerakas_napja')"
                  class="btn btn-sm btn-success ml-1"
                  title="Speichern"
                  style="padding:2px 6px;"
                >
                  ✔
                </button>
                <button
                  @mousedown.prevent="cancelEdit"
                  class="btn btn-sm btn-light ml-1"
                  title="Abbrechen"
                  style="padding:2px 6px;"
                >
                  ✕
                </button>
              </template>
              <template v-else>
                {{ truck.lerakas_napja }}
              </template>
            </td>


            <!-- Fel súly -->
                <td :class="{ 'cell-missing': truck.fel_suly == 0 }" @click.stop="enableEdit(truck, 'fel_suly')">
                    <template v-if="isEditing(truck, 'fel_suly')">
                      <input
                        ref="editInput"
                        type="number"
                        v-model="editingCell.value"
                        @keyup.enter="saveEdit(truck, 'fel_suly')"
                        @keyup.esc="cancelEdit"
                        class="form-control"
                        autofocus
                        min="0"
                        style="width: 80px; display: inline-block;"
                      />
                      <button
                        @mousedown.prevent="saveEdit(truck, 'fel_suly')"
                        class="btn btn-sm btn-success ml-1"
                        title="Speichern"
                        style="padding:2px 6px;"
                      >
                        ✔
                      </button>
                      <button
                        @mousedown.prevent="cancelEdit"
                        class="btn btn-sm btn-light ml-1"
                        title="Abbrechen"
                        style="padding:2px 6px;"
                      >
                        ✕
                      </button>
                    </template>
                    <template v-else>
                      {{ truck.fel_suly !== undefined ? truck.fel_suly : '' }}
                    </template>
                  </td>

                  <!-- Le súly -->
                    <td :class="{ 'cell-missing': truck.le_suly == 0 }" @click.stop="enableEdit(truck, 'le_suly')">
                      <template v-if="isEditing(truck, 'le_suly')">
                        <input
                          ref="editInput"
                          type="number"
                          v-model="editingCell.value"
                          @keyup.enter="saveEdit(truck, 'le_suly')"
                          @keyup.esc="cancelEdit"
                          class="form-control"
                          min="0"
                          style="width: 80px; display: inline-block;"
                          autofocus
                        />
                        <button
                          @mousedown.prevent="saveEdit(truck, 'le_suly')"
                          class="btn btn-sm btn-success ml-1"
                          title="Speichern"
                          style="padding:2px 6px;"
                        >
                          ✔
                        </button>
                        <button
                          @mousedown.prevent="cancelEdit"
                          class="btn btn-sm btn-light ml-1"
                          title="Abbrechen"
                          style="padding:2px 6px;"
                        >
                          ✕
                        </button>
                      </template>
                      <template v-else>
                        {{ truck.le_suly !== undefined ? truck.le_suly : '' }}
                      </template>
                    </td>



              <td>
              <input type="checkbox" disabled :checked="truck.eltero_ar === -1" />
            </td> 
              <td>{{ truck.eltero_kisar }}</td>
              
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Zurück-Button -->
      <button class="btn btn-secondary m-3" @click="goBack">← Vissza</button>
      <button class="btn btn-secondary m-3" @click="resetFilters">Szűrők visszaállítása</button>

    </div>
  </div>
</template>

<script>
import axiosInstance from "@/axiosInstance";
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      weeklyTrucks: [], // Liste der wöchentlichen Lieferungen
      filters: {
          m_datumtol: "",
          megrendelo: "",
          viszonylat: "",
          nagyar: "",
          kisar: "",
          felrakas_napja: "",
          lerakas_napja: "",
          rendszam: "",
          potkocsi: "",
          felsegjel: "",
          fuvarozo: "",
          fel_suly: "",
          le_suly: "",
          eltero_ar: "",
          eltero_kisar: "",
        },
      editingCell: {
        rowKey: null,   // mellek_az als eindeutiger Schlüssel
        field: null,
        value: null
      },
      editInputRef: null, // <--- Neu

    };
  },
  computed: {
      ...mapGetters(["getUserData"]),
    // Hole die postData direkt aus dem Vuex-Store
     fsz() {
        return this.getUserData ? this.getUserData.fsz : null;
  }, 
    postData() {
      return this.$store.getters.getWeekPostData || {};
    },
    filteredTrucks() {
        return this.weeklyTrucks.filter((truck) => {
          return Object.keys(this.filters).every((key) => {
            const filterValue = this.filters[key]?.toLowerCase();
            
            // Für 'viszonylat' die zusammengesetzten Felder kombinieren
            let truckValue = '';
            if (key === 'viszonylat') {
              truckValue = `${truck.felrako || ''} ${truck.lerako || ''} ${truck.cikk || ''}`.toLowerCase();
            } else {
              truckValue = truck[key]?.toString().toLowerCase() || '';
            }

            // Wenn kein Filterwert gesetzt ist, überspringen
            if (!filterValue) return true;

            // Überprüfen, ob der zusammengesetzte Wert den Filter enthält
            return truckValue.includes(filterValue);
          });
        });
      },



  },
  async mounted() {
    this.fetchWeeklyTrucks();
  },
  //**###################################################################### */
  methods: {

enableEdit(row, field) {
  let value = row[field];
  // Lösche die 0 nur beim Öffnen
  if ((field === 'fel_suly' || field === 'le_suly') && (value === 0 || value === "0")) {
    value = '';
  }
  this.editingCell = {
    rowKey: row.mellek_az,
    field,
    value
  };
  this.$nextTick(() => {
    // ref="editInput" kann als Array vorkommen, falls mehrere Inputs
    const input = Array.isArray(this.$refs.editInput) ? this.$refs.editInput[0] : this.$refs.editInput;
    if (input) {
      input.focus();
      input.select(); // Optional: markiert das ganze Feld direkt
    }
  });
},

isEditing(row, field) {
  return this.editingCell.rowKey === row.mellek_az && this.editingCell.field === field;
},
async saveEdit(row, field) {
  // Zuordnung wie gehabt!
  const fieldTypeMap = {
    felrakas_napja: "felrakasDatum",
    lerakas_napja: "lerakasDatum",
    fel_suly: "felrakoSuly",
    le_suly: "lerakoSuly"
  };
  const fieldType = fieldTypeMap[field];
  if (!fieldType) {
    this.cancelEdit();
    return;
  }

  // Vorbereiten: die Daten ins API-Format bringen!
  const changedData = {};
  changedData[field] = this.editingCell.value;
  row[field] = this.editingCell.value; // Optional, für sofortiges Update

  const postData = {
    az: row.mellek_az,
    fo_az: row.fo_az,    // falls vorhanden!
    mod_felh: this.fsz, // falls Userdaten
    data: changedData,
  };

  try {

    console.log('psotdata - saveEdit',postData);

    await axiosInstance.post('/napi_mellek/update_napimellek.php', postData);
    // Option 1: Daten komplett neu laden
    // await this.fetchWeeklyTrucks();
    // Option 2: Nur Editiermodus verlassen
    this.editingCell = { rowKey: null, field: null, value: null };
  } catch (err) {
    alert("Sikertelen mentés! Nézze meg a konzolt.");
    console.error(err);
  }
},
cancelEdit() {
  this.editingCell = { rowKey: null, field: null, value: null };
},


//************************************************************** */
    resetFilters() {
      this.filters = {
        m_datumtol: "",
        megrendelo: "",
        viszonylat: "",
        nagyar: "",
        kisar: "",
        felrakas_napja: "",
        lerakas_napja: "",
        rendszam: "",
        potkocsi: "",
        felsegjel: "",
        fuvarozo: "",
        fel_suly: "",
        le_suly: "",
        eltero_ar: "",
        eltero_kisar: "",
      };
    },

    openTruckDetails(truck){
      this.loadTruckData(truck.m_cegaz, truck.mellek_az);
    },

    async loadTruckData(cegaz, napimellekAz) {//*************************************************************************************** */
    try {
      const postData = {
        ceg_az: cegaz,
        napimellek_az: napimellekAz
      };

      // API-Aufruf zum Laden der Truck-Daten mit `ceg_az` und `napimellek_az`
      const response = await axiosInstance.post('/napi_mellek/list_truck.php', postData);

      // Überprüfen, ob die Antwort erfolgreich ist und Daten vorhanden sind
      if (response.data && response.data.data) {
        ////console.log('Truck-Daten empfangen:', response.data.data[0]);

        // Committe die geladenen Truck-Daten in den Vuex-Store
        this.$store.commit('setTruckData', response.data.data[0]);

        // Navigiere zur entsprechenden Seite: `editTruck` für Bearbeitung oder `newTruck` für neue Lieferungen
        const targetPage =  'editTruck';
        this.$router.push({ name: targetPage });
      } else {
        ////console.error('Fehler beim Laden der Truck-Daten.');
      }
    } catch (error) {
      ////console.error('Fehler beim API-Aufruf:', error);
    }
  },

    async fetchWeeklyTrucks() {
      const postData = this.$store.getters.getWeekPostData;

      if (!postData || !postData.ceg_az || !postData.fsz) {
        console.error("Keine gültigen postData im Store gefunden.");
        return;
      }

      try {
        console.log("Post Data:", postData);
        const response = await axiosInstance.post(
          "/megrendeles/heti_lista_fuvar.php",
          postData
        );

        if (response.status === 200 && response.data && response.data.data) {
          this.weeklyTrucks = response.data.data;
          console.log("Weekly Trucks:", this.weeklyTrucks);
        } else {
          console.error("Fehler beim Abrufen der wöchentlichen Lieferungen:", response);
        }
      } catch (error) {
        console.error("API-Fehler:", error);
      }
    },
    goBack() {
      this.$router.back();
    },
  },
};
</script>

<style scoped>

.table-responsive-wrapper {
max-height: 700px; /* Maximale Höhe der Tabelle mit Scrollbalken */
overflow-y: auto;  /* Vertikaler Scrollbalken */
position: relative;
}

.sticky-header th {
position: sticky;  /* Sticky macht die Kopfzeile fixiert */
top: 0;            /* Hält die Kopfzeile oben */
background-color: white; /* Hintergrundfarbe der Kopfzeile */
z-index: 2;        /* Sicherstellen, dass die Kopfzeile vor den Daten bleibt */
}

.table {
  min-width: 1500px; /* Erhöhte Mindestbreite für horizontales Scrollen */
  border-collapse: collapse;
}

.table th,
.table td {
  padding: 3px; /* Weniger Padding für kompaktere Darstellung */
  text-align: left;
  border: 1px solid #ddd; /* Rahmen */
  font-size: 12px; /* Kleinere Schriftgröße */
}

h3 {
  margin-bottom: 10px;
}

.input-with-icon {
  position: relative; /* Ermöglicht die absolute Positionierung des Icons */
}

.input-with-icon i {
  position: absolute;
  top: 50%; /* Vertikal zentrieren */
  left: 10px; /* Abstand zum linken Rand */
  transform: translateY(-50%);
  color: #6c757d; /* Graue Farbe für das Icon */
}

.input-with-icon input {
  padding-left: 30px; /* Platz für das Icon schaffen */
}

.input-with-icon input {
  padding-left: 30px; /* Platz für das Icon schaffen */
  font-size: 12px; /* Kleinere Schriftgröße */
  height: 30px; /* Optional: Reduziere die Höhe des Eingabefelds */
}

.cell-missing {
  background: rgb(248, 221, 221) !important;
  color: rgb(248, 2, 2) !important;
}


</style>
